const IS_SERVER_SIDE = typeof window === "undefined"
export const isMobileDevices = () => {
    if (IS_SERVER_SIDE) {
        return false;
    }
    const nav = window?.navigator;
    if (nav?.userAgent.match(/Android/i)
        || nav?.userAgent.match(/webOS/i)
        || nav?.userAgent.match(/iPhone/i)
        || nav?.userAgent.match(/iPad/i)
        || nav?.userAgent.match(/iPod/i)
        || nav?.userAgent.match(/BlackBerry/i)
        || nav?.userAgent.match(/Windows Phone/i)) {
        return true;
    } else {
        return false;
    }
}

export const getMobileOperatingSystem = () => {
    if (IS_SERVER_SIDE){
        return 'unknown'
    }
    
    // NOSONAR
    const userAgent = window?.navigator?.userAgent || window?.navigator?.vendor || (window as any)?.opera; // NOSONAR

    // iOS detection
    if (/iPhone|iPad|iPod/i.test(userAgent)) {
        return 'iOS';
    }

    // Android detection
    if (/android/i.test(userAgent)) {
        return 'Android';
    }

    // Other or unknown
    return 'unknown';
}
